import { createFileRoute } from "@tanstack/react-router";
import { BrandStatusPage } from "@/components/BrandStatusPage";

export const Route = createFileRoute("/404")({
  component: () => (
    <BrandStatusPage
      code="404"
      title="Trang này không có trong kho"
      description="Đường dẫn có thể đã đổi. Quay về trang chính để tiếp tục."
    />
  ),
});
